<header class="fixed inset-x-0 top-0 z-50 border-b border-slate-200/70 bg-white/80 backdrop-blur-xl">
  <div class="mx-auto flex max-w-page items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
    <a routerLink="/" class="flex items-center gap-3">
      <img
        src="assets/brand/logo.svg"
        width="40"
        height="40"
        alt="FormOps logo"
        class="h-10 w-10 shrink-0" />

      <div>
        <p class="text-h6 text-slate-950">FormOps</p>
        <p class="text-caption text-slate-500">AI Workflow Platform</p>
      </div>
    </a>

    <nav class="hidden items-center gap-8 text-body2 text-slate-600 lg:flex">
      <a routerLink="/use-cases" class="transition hover:text-slate-950">Use Cases</a>
      <a href="#features" class="transition hover:text-slate-950">Features</a>
      <a href="#ai" class="transition hover:text-slate-950">AI Insights</a>
      <a href="#integrations" class="transition hover:text-slate-950">Integrations</a>
      <a routerLink="/pricing" class="transition hover:text-slate-950">Pricing</a>
    </nav>

    <div class="flex items-center gap-3">
      <lib-signal-button
        appearance="text"
        [fullWidth]="false"
        (clicked)="navigateToMyForms()">
        My Forms
      </lib-signal-button>

      <lib-signal-button
        appearance="text"
        [fullWidth]="false"
        (clicked)="navigateToLogin()">
        Sign in
      </lib-signal-button>

      <lib-signal-button
        appearance="primary"
        [fullWidth]="false"
        (clicked)="navigateToSignup()">
        Start free
      </lib-signal-button>
    </div>
  </div>
</header>
